<button class="wep-ag-grid-cell-editor-input-readonly__button"
        (click)="onClick()"
        (keydown)="keyDown($event)"
        #button
        tabindex="0">
    {{params.formatValue(formGroup.controls['cell'].value)}}
</button>